import { Button, Form, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { deleteShortUrl, getShortUrls } from '../../services/URLShortnerService';
import DeleteWarningModalWithAction from '../Common/DeleteWarningModalWithAction';
import TableWithSorter from '../Common/TableWithSorter';
import LoadingSpinner from '../shared/components/LoadingSpinner';
import ShortUrlSearch from './components/ShortUrlSearch';
import ShortUrlAdd from './ShortUrlAdd';
import ShortUrlEdit from './ShortUrlEdit';
const { Text } = Typography;
const shortURLBase = `${process.env.REACT_APP_SHORT_URL_LINK?process.env.REACT_APP_SHORT_URL_LINK:'nasacademy.com'}`;

const ShortUrlWrapper = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [error, setError] = useState();
  const [urlObjects, setUrlObjects] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [toDelete, setToDelete] = useState({});
  const [toEdit, setToEdit] = useState({});

  function toggleAddModal() {
    setIsAddModalOpen((prev) => !prev);
  }

  function toggleEditModal() {
    setIsEditModalOpen((prev) => !prev);
  }
  

  // getting data from backend
  const getData = async (
    newParams,
    limit = pageSize,
    currentPage = current
  ) => {
    const params = newParams ? newParams : currentParams;
    setIsLoading(false);
    await getShortUrls(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          let shortURLs = res.data.paginatedList;
          const formattedResData = shortURLs.map((item) => {
            return {
              _id: item._id,
              name: item.name,
              shortUrl: shortURLBase + '/' + item.urlCode,
              urlCode: item.urlCode,
              longUrl: item.longUrl,
            };
          });
          
          setUrlObjects(formattedResData);
          setTotalCount(res.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current);
    setCurrent(data.current);
    setPageSize(data.pageSize);
  };

  useEffect(() => {
    getData();
  }, [current, hasChanged, currentParams]);

  const [form] = Form.useForm();
  
  const onSearch = (params) => {
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    setCurrent(1);
    getData({}, pageSize, 1);
  };

  const handleDelete = (record) => {
    console.log("Item to be deleted", record);
    setIsDeleteModalVisible(true);
    setToDelete(record);
    setHasChanged(true);
  };

  const onDelete = async () => {
    console.log("toDelete: ", toDelete);
    if(toDelete){
      await deleteShortUrl(toDelete._id);
    }
  }

  const handleEdit = (record) => {
    console.log("Item to be Edited", record);
    setHasChanged(true);
    toggleEditModal();
    setIsEditModalOpen(true);
    setToEdit(record);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'urlCode',
      key: 'urlCode',
    },
    {
      title: 'Short Url',
      dataIndex: 'shortUrl',
      key: 'shortUrl',
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: 'Destination',
      dataIndex: 'longUrl',
      key: 'longUrl',
      render: (text) => (
        <Text ellipsis={true} style={{ maxWidth: '30vw' }}>
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textOverflow: 'ellipsis' }}
          >
            {text}
          </a>
        </Text>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Button onClick={() => handleEdit(record)}>Edit</Button>
          <Button onClick={() => handleDelete(record)}>Delete</Button>
        </Space>
      ),
    },
  ];

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <>
      <h2>All links will be at {shortURLBase}/[code]</h2>
      <div>
        <div
          style={{
            display: 'inline-block',
            marginRight: '10%',
          }}
        >
          <p>How to Shorten a url?</p>
          <p>Name - What is the name of the URL?</p>
          <p>URL Code - code you want to link it to</p>
          <p>Destination URL - the long URL you want to shorten</p>
        </div>
        <div style={{ display: 'inline-block' }}>
          <p>Example:</p>
          <p>- URL you want to shorten: www.pinsandneedles.ml</p>
          <p>- In the name field, insert "Best-Website-In-The-World"</p>
          <p>- In the URL Code, insert "BestWebsiteInTheWorld" - NO SPACES!</p>
          <p>- In Destination URL, insert "www.pinsandneedles.ml"</p>
        </div>
      </div>
      <div>
        <h2>Search By Short Code</h2>
        <ShortUrlSearch form={form} onSearch={onSearch} onReset={onReset} />
      </div>
      <Button type="primary" onClick={toggleAddModal}>
          Add Short Url
        </Button>
      <ShortUrlAdd isOpen={isAddModalOpen} toggle={toggleAddModal} />
      <ShortUrlEdit
        shortUrl={toEdit}
        isOpen={isEditModalOpen}
        toggle={toggleEditModal}
      />
      {urlObjects.length > 0 ? (
        <div>
        <TableWithSorter
            loading={isLoading}
            tableLayout="auto"
            scroll={{ x: 1000 }}
            expandable={{ defaultExpandAllRows: true }}
            dataSource={urlObjects}
            columns={columns}
            pagination={{
              defaultPageSize: 20,
              total: totalCount,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
            onChange={onPaginationChange}
          />
          <DeleteWarningModalWithAction
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            action={onDelete}
          />
        </div>
      ) : (
        <div>No record found</div>
      )}
    </>
  );
};

export default ShortUrlWrapper;
